import { useState, useCallback } from 'react';
//import api from '../api/axios.js';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api';

// Admin auth function to be used in the LoginCard
// Again, this is basically a copy of the user auth but for admin accounts

export const useAdminAuth = () => {
    const [user, setUser] = useState(null);
    //const [loading, setLoading] = useState(true);

    // Login logic
    const login = async ({uname,upass}) => {
        const response = await fetch(`${API_BASE_URL}/auth-admin/login`, {
            method: 'POST',
            credentials: 'include', // Required to send cookies
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ uname, upass })
        });
        setUser(response.body.uid);
        return response
    }
    const verify = useCallback(async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/auth-admin/verify`, {
                method: 'GET',
                credentials: 'include' // Required to send cookies
            });
            if (response.ok) {
                return true;
            } else {
                setUser(null);
                return false;
            }
            //setIsVerified(response.ok); // Set authentication status
        } catch (error) {
            console.error("Verification error:", error);
            return false;
            //setIsVerified(false);
        }
    }, []);

    const logout = async () => {
        try {
          const response = await fetch(`${API_BASE_URL}/auth-admin/logout`, {
            method: 'POST',
            credentials: 'include', // Ensures the cookie is sent for this request
            headers: { 'Content-Type': 'application/json' },
          });
      
          if (response.ok) {
            localStorage.clear();
            console.log('Logged out successfully');
          } else {
            console.error('Error logging out');
          }
        } catch (error) {
          console.error('Logout error:', error);
        }
    };

    return {
        user,
        isAuth: !!user,
        login,
        logout,
        verify,
    }
}

    // const [user, setUser] = useState(null);
    // const [loading, setLoading] = useState(true);

    // // Login logic
    // const login = async (creds) => {
    //     try {
    //         const res = await api.post('/auth-admin/login', creds) // post login creds to the API
    //         const { token, username } = res.data // Get JWT token from the API post

    //         // Check that the JWT token exists
    //         if (token) {
    //             localStorage.setItem('token', token)
    //             localStorage.setItem('username', username)
    //             await verify()
    //             return true
    //         }
    //     } catch (error) {
    //         console.error("Login failed:", error)
    //         return false   
    //     }
    // }

    // // Verify the token - useCallback keeps the validity of the token cached (I think??)
    // const verify = useCallback(async () => {
    //     // Get the token set by the 'login' function
    //     const token = localStorage.getItem('token')

    //     // If the token doesn't exist, set the user to null
    //     if (!token) {
    //         setUser(null)
    //         setLoading(false)
    //         return false
    //     }

    //     // Otherwise, validate the token by sending a post request to '/auth/verify'
    //     try {
    //         const res = await api.get('/auth-admin/verify', { 'headers': { 'token': token }}) 
            
    //         // If this is what is returned, then the token is valid
    //         if (res.data === "Token is verified") {
    //             const username = localStorage.getItem('username')
    //             setUser({username}) // Set the current user to the username
    //             setLoading(false)
    //             return true
    //         } else {
    //             // Token wasn't verified
    //             logout()
    //             return false
    //         }
    //     } catch (error) {
    //         // Log the user out on failure
    //         logout()
    //         return false
    //     }
    // }, [])

    // // Logout - set current user to 'null' and get rid of the token
    // const logout = () => {
    //     localStorage.removeItem('token')
    //     setUser(null)
    //     return true
    // }